import { ReactNode } from 'react';
import {
  AccountCircleOutlined,
  GroupOutlined,
  ReceiptLongOutlined,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import i18n from '../i18n/i18n';
import { Dashboard } from '@components';

type Props = {
  children: ReactNode | ReactNode[];
};
export default function SuperadminDashboard({ children }: Props) {
  const { t } = useTranslation('translation', { i18n });

  return (
    <Dashboard
      defaultState="/"
      menuItems={[
        [
          {
            name: t('DashboardMenu.SuperAdmin.Customers'),
            dashboardAreaLink: '/',
            icon: GroupOutlined,
          },
          {
            name: t('DashboardMenu.SuperAdmin.CreateCustomer'),
            dashboardAreaLink: '/create-customer',
            icon: AccountCircleOutlined,
          },
          {
            name: t('DashboardMenu.SuperAdmin.CreateCustomerAdmin'),
            dashboardAreaLink: '/create-customer-admin',
            icon: AccountCircleOutlined,
          },
        ],
        [
          {
            name: t('DashboardMenu.SuperAdmin.Transactions'),
            dashboardAreaLink: '/transactions',
            icon: ReceiptLongOutlined,
          },
        ],
      ]}
    >
      {children}
    </Dashboard>
  );
}
